import { getDeviceById, getDistinctGroupsOfDevs, getDistinctSerialConnectionsOfDevs } from "src/components/Planner/planner/uDev";
import { removeDevAllOccurrences, removeTheseDevs } from "src/components/Planner/planner/uDev-dom";
import { removeDevice } from 'src/components/Planner/planner/deviceDrawing';
import {
    DeleteMultipleDevicesAction,
    DeleteSingleDeviceAction,
} from 'src/components/Planner/planner/history/device-actions';
import { PlannerGlobals } from 'src/components/Planner/planner/planner-globals';

export enum DeleteScope {
    SINGLE = 'SINGLE',
    ROOM = 'ROOM',
    FLOOR = 'FLOOR',
    FLOOR_ALL = 'FLOOR_ALL',
}

export function executeDelete(
    deviceId: number,
    scope: DeleteScope,
    onComplete: (success: boolean) => void
): void {
    const device = getDeviceById(deviceId);
    if (!device) {
        onComplete(false);
        return;
    }

    switch (scope) {
        case DeleteScope.SINGLE: {
            removeDevice(null, deviceId)
                .done((params: any) => {
                    const action = new DeleteSingleDeviceAction(params);
                    PlannerGlobals.plannerHistoryManager?.addHistoryEntry(action);
                    onComplete(true);
                })
                .fail(() => onComplete(false));
            break;
        }
        case DeleteScope.ROOM: {
            removeDevAllOccurrences(deviceId, true, (deletedDevs: any[], groups: any[], measures: any[], serConns: any[]) => {
                const action = new DeleteMultipleDevicesAction(deletedDevs, groups, measures, serConns);
                PlannerGlobals.plannerHistoryManager?.addHistoryEntry(action);
                onComplete(true);
            });
            break;
        }
        case DeleteScope.FLOOR: {
            removeDevAllOccurrences(deviceId, false, (deletedDevs: any[], groups: any[], measures: any[], serConns: any[]) => {
                const action = new DeleteMultipleDevicesAction(deletedDevs, groups, measures, serConns);
                PlannerGlobals.plannerHistoryManager?.addHistoryEntry(action);
                onComplete(true);
            });
            break;
        }
        case DeleteScope.FLOOR_ALL: {
            const allDevices = PlannerGlobals.devices ?? [];
            const groups = getDistinctGroupsOfDevs(allDevices);
            const serConns = getDistinctSerialConnectionsOfDevs(allDevices);

            removeTheseDevs(allDevices, (deletedDevs: any[]) => {
                const action = new DeleteMultipleDevicesAction(deletedDevs, groups, [], serConns);
                PlannerGlobals.plannerHistoryManager?.addHistoryEntry(action);
                onComplete(true);
            });
            break;
        }
    }
}